import { sanitizeString, validaCnpj, regexEmail } from "../../../utils/Utils";

export const criarPayload = (values) => {
  const numero_limpo = sanitizeString(values.numero_cartao);
  const [mes, ano_curto] = values.validade.split("/");

  return {
    passo: 2,
    nome_titular: values.nome_titular,
    cnpj_titular: sanitizeString(values.cnpj_titular),
    numero_cartao: numero_limpo,
    mes_validade: parseInt(mes, 10),
    ano_validade: parseInt("20" + ano_curto, 10),
    pagamento_principal: values.pagamento_principal,
  };
};

export const criarPayloadCartao = (values) => {
  const numero_limpo = sanitizeString(values.numero_cartao);
  const [mes, ano_curto] = values.validade.split("/");

  return {
    nome_titular: values.nome_titular,
    cnpj_titular: sanitizeString(values.cnpj_titular),
    numero_cartao: numero_limpo,
    mes_validade: parseInt(mes, 10),
    ano_validade: parseInt("20" + ano_curto, 10),
    cvv: sanitizeString(values.cvv),
    principal: values.pagamento_principal,
  };
};

export const validarDadosEmpresa = (values) => {
  const erros = {};

  if (!values.razao_social || !values.razao_social.trim()) {
    erros.razao_social = "Razão social é obrigatória.";
  }

  if (!values.cnpj) {
    erros.cnpj = "CNPJ é obrigatório.";
  } else {
    const cnpj_limpo = sanitizeString(values.cnpj);

    if (cnpj_limpo.length !== 14) {
      erros.cnpj = "CNPJ deve conter 14 dígitos.";
    } else if (!validaCnpj(cnpj_limpo)) {
      erros.cnpj = "O CNPJ informado é inválido.";
    }
  }

  if (!values.email) {
    erros.email = "E-mail é obrigatório.";
  } else if (!regexEmail.test(values.email)) {
    erros.email = "Informe um e-mail válido.";
  }

  return erros;
};

export const criarPayloadEmpresa = (values) => {
  return {
    razao_social: values.razao_social.trim(),
    cnpj: sanitizeString(values.cnpj),
    email: values.email.trim(),
  };
};

export const validarSenha = (values) => {
  const REGEX_SENHA_FORTE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%&]).+$/;
  const erros = {};

  if (!values.current_password) {
    erros.current_password = "Senha atual é obrigatória.";
  }

  if (!values.new_password) {
    erros.new_password = "Nova senha é obrigatória.";
  } else if (values.new_password.length < 8) {
    erros.new_password = "A senha deve ter no mínimo 8 caracteres.";
  } else if (!REGEX_SENHA_FORTE.test(values.new_password)) {
    erros.new_password = "A senha deve conter pelo menos 1 letra minúscula, 1 maiúscula, 1 número e 1 caractere especial (!, @, #, $, %, &).";
  }

  if (!values.confirm_password) {
    erros.confirm_password = "Confirmação de senha é obrigatória.";
  } else if (values.new_password && values.confirm_password !== values.new_password) {
    erros.confirm_password = "As senhas não conferem.";
  }

  return erros;
};
